export const defaultHousePriceValue = 350_000

export const calculateBudgetRange = (budgetRange: {
  min: number
  max: number
}) => {
  if (budgetRange.max === Infinity) {
    return 630_000
  }
  return (budgetRange.min + budgetRange.max) / 2
}
